<template lang="pug">
.u-margin-top-8x
  h3.p-title.p-title--icon {{$t('shared.risk_objects.generic.house_rental')}}
    Icon(icon="house" classes="p-title__icon")
  Ownership(risk="house_rental" risk_object="rc")
  Ownership(risk="house_rental" risk_object="content")
  Ownership(risk="house_rental" risk_object="theft")
</template>

<script>
import Icon from '../shared/Icon'
import Ownership from './Ownership'

export default {
  components: {
    Icon,
    Ownership
  }
}
</script>

<style lang="scss" scoped>
// div {
//   margin-top: 4rem;
// }
</style>



// WEBPACK FOOTER //
// src/components/insurances/HouseRental.vue